/**
 * @ Author: Housefolios
 * @ Create Time: 2025-07-08 17:47:11
 * @ Modified by: David Helmick
 * @ Modified time: 2025-07-08 18:24:47
 * @ Description: Routes for when you are not signed in
 */

import React, { lazy } from 'react'
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  Outlet,
  useNavigate,
} from 'react-router'

// Layout Blueprints

import {
  LeftSidebar,
  MinimalLayout,
} from '../../layout-blueprints'

import CreateAccountPage from '../../housefolios-pages/CreateAccount'
import ForgotPasswordPage from '../../housefolios-pages/ForgotPassword'
import EnterpriseAccountPage from '../../housefolios-pages/EnterpriseAccount'
import FreeAccount from '../../housefolios-pages/FreeAccount'

import ResetPasswordPage from '../../housefolios-pages/ResetPassword'
import SignInPage from '../../housefolios-pages/SignIn'
import PublicLanding from '@/housefolios-pages/PublicLanding'
import PublicProperty from '@/housefolios-pages/PublicProperty'
const PDFContainer = lazy(
  () =>
    import(
      '../../housefolios-components/PropertyContainer/Proforma/pdfContainer'
    ),
)
import ExternalSignIn from '@/housefolios-components/SignIn/ExternalSignIn'

import PublicMarketplacePage from '@/housefolios-pages/PublicMarketplace'
import PublicPropertyDashboardPage from '@/housefolios-pages/PublicPropertyDashboard'
import ProformaRedirect from '../../housefolios-components/Routes/ProformaRedirect'
import Legal from '@/housefolios-pages/Legal'
import Terms from '@/housefolios-pages/Terms'
import Privacy from '@/housefolios-pages/Privacy'

import ArticlePage from '../../housefolios-pages/ArticlePage'

const NotSignedIn = (props) => {
  const {
    refetch,
    affiliate,
    setOpenAnalyzeAreaTour,
    setOpenAnalyzeCompsTour,
    setOpenChooseStrategyTour,
    setOpenFeedbackTour,
    setOpenTakeActionTour,
    setOpenTour,
    setOpenVerifyFinancialsTour,
  } = props

  const location = useLocation()

  const navigate = useNavigate()

  return (
    <Routes>
      <Route element={<MinimalLayout />}>
        <Route path="/createAccount" element={<Outlet />}>
          <Route
            index
            element={<CreateAccountPage refetch={refetch} />}
          />
          <Route
            path=":planName"
            element={<CreateAccountPage refetch={refetch} />}
          />
        </Route>
        <Route
          path="/signin"
          element={<SignInPage refetch={refetch} />}
        />
        <Route
          path="/enterpriseAccount"
          element={<EnterpriseAccountPage />}
        />
        <Route path="/free-account" element={<FreeAccount />} />
        <Route
          path="/ForgotPassword"
          element={<ForgotPasswordPage />}
        />

        <Route path="/ResetPassword" element={<Outlet />}>
          {/* No token: explain and point to Forgot Password instead of a blank page. */}
          <Route index element={<ResetPasswordPage />} />
          <Route
            path=":token/:orgName"
            element={<ResetPasswordPage />}
          />
          <Route path=":token" element={<ResetPasswordPage />} />
        </Route>

        <Route path="/articles/:id" element={<ArticlePage />} />

        <Route
          path="/externalVisit/"
          element={
            <ExternalSignIn refetch={refetch} navigate={navigate} />
          }
        />
        <Route path="/publiclanding" element={<PublicLanding />} />
        <Route
          path="/publicproperty/:view"
          element={<PublicProperty />}
        />
        <Route
          path="/marketplace/:url"
          element={<PublicMarketplacePage />}
        />
        <Route
          path="/property/:id/proforma/:type"
          element={<PDFContainer />}
        />
      </Route>

      <Route
        element={
          <LeftSidebar
            collapsed
            setOpenFeedbackTour={setOpenFeedbackTour}
          />
        }
      >
        <Route
          path="/public-property-details/:id/:view"
          element={
            <PublicPropertyDashboardPage
              setIsOpen={setOpenTour}
              setIsOpenVerifyFinancialsTour={
                setOpenVerifyFinancialsTour
              }
              setIsOpenAnalyzeCompsTour={setOpenAnalyzeCompsTour}
              setIsOpenChooseStrategyTour={setOpenChooseStrategyTour}
              setIsOpenAnalyzeAreaTour={setOpenAnalyzeAreaTour}
              setIsOpenTakeActionTour={setOpenTakeActionTour}
            />
          }
        />
      </Route>

      {/* Redirects */}
      <Route
        path="/sharedPortfolio"
        element={<ProformaRedirect isLoggedIn={false} />}
      />
      <Route
        path="/property-details/:id/proforma/:type"
        element={<ProformaRedirect isLoggedIn={false} />}
      />
      <Route
        path="/*"
        element={<Navigate to={'/signin' + window.location.search} />}
      />
      <Route
        path="/legal"
        element={<Legal affiliate={affiliate?.memberValue} />}
      />
      <Route
        path="/terms"
        element={<Terms affiliate={affiliate?.memberValue} />}
      />
      <Route
        path="/privacy"
        element={<Privacy affiliate={affiliate?.memberValue} />}
      />
    </Routes>
  )
}

export default NotSignedIn
